export default __webpack_public_path__ + "static/media/T18.225b3e39.png";